
import { defineComponent, SetupContext, ref, computed } from "vue";
export default defineComponent({
  name: "SearchInputView",
  props: {
    /**
     * 検索キーワード
     */
    inputText: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const keyword = ref(props.inputText);
    /**
     * 検索キーワードを取得、設定する
     */
    const keywordComputed = computed({
      get: () => keyword.value,
      set: value => (keyword.value = value)
    });
    /**
     * タグ押下を通知する
     */
    const setFocusKeyword = () => {
      context.emit("set-focus", keywordComputed.value);
    };

    return {
      keywordComputed,
      setFocusKeyword
    };
  }
});
